// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"3331ea28","816":"5b2fdb43"}[chunkId] + ".chunk.js";
};